import { render } from "./Contenidos.vue?vue&type=template&id=66826ac0"
const script = {}
script.render = render

export default script